// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O0KA","colBig":"styles_colBig__2T_FE","colSmall":"styles_colSmall__3YO1L","shopifyNameWrapper":"styles_shopifyNameWrapper__1gxUg"};